import React, {useCallback, useEffect, useState} from "react";
import "../General/General.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import CancelModal from "../General/Cancel";
import "./AddServiceRequest.css";
import {useLocation, useNavigate} from "react-router-dom";
import {InputAdornment, Select, TextField, Tooltip} from "@mui/material";
import Stack from "@mui/material/Stack";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import DeleteModal from "../General/DeleteServiceRequest";
import keycloak from "../../Keycloak";
import CircularProgress from '@mui/material/CircularProgress';
import JiraProjectSearch from "../General/JiraProjectSearch";
import HarvestProjectSearch from "../General/HarvestProjectSearch";
import {getServiceRequestByServiceRequestId} from "../../utilities/ServiceRequestAPI";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {uploadedFiles} from "../DragAndDrop";
import {showSaveError, showSaveSuccessMessage} from "../toastUtils";
import {readFileAsArrayBuffer} from "./AddServiceRequest";
import AgreementsTable from "../Clients/AgreementsTable";

const projectType = [
    {
        value: 0,
        label: "Team Augmentation",
    },
    {
        value: 1,
        label: "Fixed Cost Project",
    },
    {
        value: 2,
        label: "Support & Maintenance",
    },
    {
        value: 3,
        label: "Dedicated Product Development Team"
    },
    {
        value: 4,
        label: "Time & Materials"
    },
];

const rollOverRules = [
    {
        value: true,
        label: "Expires",
    },
    {
        value: false,
        label: "Rolls Over",
    },
];

const rollOverHoursType = [
    {
        value: 0,
        label: "Remaining Hours in Month",
    },
    {
        value: 1,
        label: "% of Remaining Hours in Month",
    },
];

const expiryType = [
    {
        value: 0,
        label: "Current month",
    },
    {
        value: 1,
        label: "Service Request end date",

    },
];

const invoicingRule = [
    {
        value: 0,
        label: "In Advance",
    },
    {
        value: 1,
        label: "In Arrears",
    },
];

const notify = [
    "Webtonic System Admin",
    "Webtonic Account Manager",
    "Webtonic Delivery Manager",
    "Webtonic Basic",
    "Client Admin",
    "Client Basic",
];


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 50,
        },
    },
};

const EditServiceRequest = () => {
    const navigate = useNavigate();
    const [personName, setPersonName] = React.useState([]);
    const [initialDocuments, setInitialDocuments] = useState([]);

    // Data structure of client and related data
    const [data, setServiceRequestData] = useState({
        id: 0,
        alertThreshold: 0,
        daysInArrears: 0,
        invoicingRule: 0,
        notifyee: personName,
        projectType: "",
        rollover: "",
        clientId: 0,
        jiraProjectId: 0,
        projectId: 0,
        serviceRequestId: 0,
        client: {
            clientId: 0,
        },
        harvestProject: {
            id: 0,
            name: "",
            clientId: 0,
            clientName: "",
            startsOn: "",
            endsOn: "",
            budget: "",
        },
        jiraProject: {
            id: 0,
            name: "",
            createdAt: "",
        },
        documents:[
            {
                fileName: "",
                fileType: "",
                fileBytes: null
            }
        ]
    });

    //triggers when file is selected with click
    const handleChange = function (e) {
        e.preventDefault();
        e.stopPropagation();
        // Fetch name and value from changed element
        let { name, value } = e.target;

        // If the name includes ".", it is a nested object
        if (name.includes(".")) {
            // Get the nested attribute
            const [nestedObject, nestedProperty] = name.split(".", 2);

            // Update the value and name to accommodate nested objects
            value = assignPartialObject(data[nestedObject], { [nestedProperty]: value });
            name = nestedObject;
        }

        // Update the state of the form data
        setServiceRequestData({...data, [name]: value})
        console.log(data)

        if (name.includes("projectType")) {
            setProjectType(e.target.value);
        }

        if (name.includes("RollOverRules")) {
            const showRollOverHoursDiv = document.getElementById("showRollOverHoursDiv");
            const showExpiryTypeDiv = document.getElementById("showExpiryTypeDiv");
            console.log(e.target.value, "Roll Over Rules Value");
            if (e.target.value === true) {
                showRollOverHoursDiv.style.display = "none";
                showExpiryTypeDiv.style.display = "block";
            } else {
                showExpiryTypeDiv.style.display = "none";
                showRollOverHoursDiv.style.display = "block";
            }
            data.rollOver=e.target.value;
            setRollOverRules(e.target.value);
        }

        if(name.includes("notifyee")) {
            setPersonName(
                typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value,
            );
        }

        if(name.includes("expiryType")) {
            setExpiryType(e.target.value);
        }

        if (name.includes("invoicingRule")) {
            const value = e.target.value
            const daysInArrearsDiv = document.getElementById("daysInArrearsDiv");
            if (value === 1) {
                daysInArrearsDiv.style.display = "block";
            } else {
                daysInArrearsDiv.style.display = "none";
                daysInArrearsDiv.value = 0;
            }
            setInvoicingRule(e.target.value);
        }

        if (name.includes("Arrears")) {
            console.log("Days in arrears");
            console.log(e.target.value);
            if (e.target.value < 1 || e.target.value > 29) {
                document.getElementById("Arrears").style.color = "red";
            } else {
                document.getElementById("Arrears").style.color = "black";
            }
        }

        setEnableSave(true);
    };

    /**
     * Add or update only some of the attributes of an existing object.
     *
     * @param existingObject
     * @param newObject
     * @returns object
     */
    const assignPartialObject = (existingObject, newObject) => {
        return Object.assign(existingObject, newObject);
    }

    const handleDocumentUpdate = (file) => {
        if(file){
            setEnableSave(true);
        }
    }

    const [openModal, setOpenModal] = useState(false);
    const [deleteOpenModal, setDeleteOpenModal] = useState(false);

    const style = {
        "& label.Mui-focused": {
            color: "#EC8D2B",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#EC8D2B",
            },
        },
    };

    const [showSpinner] = useState(false);
    const compulsoryFieldsMessage = "Please complete the compulsory fields on the form below"
    const [saveClicked, setSaveClicked] = useState(false);

    const submitServiceRequest = async (event) => {
        event.preventDefault();

        if ((data.daysInArrears < 1 || data.daysInArrears > 29) && (data.invoicingRule === 1)) {
            showSaveError("Please check Harvest and enter the days in arrears rule between 1-29")
            console.log("arrears not between 1-29");
        } else {
            if (saveClicked) {
                if (data.alertThreshold === '') {
                    showSaveError(compulsoryFieldsMessage)
                    window.scrollTo(0, 0);
                    document.getElementById('alertThreshold').focus();
                } else if (!openModal) {
                    try {
                        const headers = new Headers();
                        headers.append('Authorization', 'Bearer ' + keycloak.token);
                        headers.append('Content-Type', 'application/json')

                        if (uploadedFiles) {
                            if (uploadedFiles.length > 0) {
                                let documents = [];
                                for (let i = 0; i < uploadedFiles.length; i++) {
                                    console.log(uploadedFiles[i])
                                    const file = uploadedFiles[i];
                                    const fileBytes = await readFileAsArrayBuffer(file);

                                    documents.push({
                                        fileName : file.name,
                                        fileType : file.type,
                                        fileBytes : Array.from(new Uint8Array(fileBytes))
                                    })
                                    data.documents = documents;
                                }
                            }
                        } else {
                            data.documents = [];
                        }

                        data.notifyee = personName.toString();
                        data.harvestProject.id = data.projectId;
                        data.jiraProject.id = data.jiraProjectId;
                        data.clientId = data.client.clientId;
                        data.rollOver = populatedRollOverRules;
                        data.serviceRequestId = data.id;
                        if (data.daysInArrears == null) {
                            data.daysInArrears = 0;
                        }

                        console.log(data)

                        const response = await fetch(`api/service-request/${data.id}`, {
                            method: "PUT",
                            body: JSON.stringify(data),
                            headers: headers,
                        });
                        console.log(response)

                        if (response.ok) {
                            const responseData = await response.json();
                            console.log(responseData);
                            showSaveSuccessMessage("Service request has been updated successfully");
                            navigate("/ServiceRequestList");
                            window.scrollTo(0, 0);
                        } else {
                            const error = await response.text();
                            console.log(error)
                            showSaveError(error);
                        }
                    } catch (err) {
                        console.log("try...catch: ", err);
                        showSaveError("An error occurred, please try again");
                        window.scrollTo(0, 0);
                    }
                }
            }
        }
    };


    let durationWidth;
    if (window.innerWidth >= 1024) {

        durationWidth = "37.2%";
    }
    else if (window.innerWidth > 480 && window.innerWidth < 1024) {

        durationWidth = "35.93%";
    }
    else {
        
        durationWidth = "35.2%";
    }

    const [populatedProjectType, setProjectType] = useState('');
    const [populatedExpiryType, setExpiryType] = useState('');
    const [populatedRollOverRules, setRollOverRules] = useState(true);
    const [populatedInvoicingRule, setInvoicingRule] = useState('');
    const [enableSave, setEnableSave] = useState(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const serviceRequestId = searchParams.get('serviceRequestId');

    const jiraFieldChange = (event) => {
        data.jiraProjectId = event;
        setEnableSave(true);
        console.log("jiraFieldChange", event);
        console.log(data);
    };

    const harvestFieldChange = (event) => {
        data.projectId = event;
        console.log(event)
        setEnableSave(true);
        console.log("harvestFieldChange", event);
        console.log(data);
    };

    const callServiceRequestInfo = useCallback(() => {
        getServiceRequestByServiceRequestId(serviceRequestId, keycloak.token)
            .then((serviceRequest) => {
                setServiceRequestData(serviceRequest);
                serviceRequest.projectId=serviceRequest.harvestProject.id;
                serviceRequest.jiraProjectId=serviceRequest.jiraProject.id;
                setProjectType(serviceRequest.projectType);
                setRollOverRules(serviceRequest.rollOver);
                if (serviceRequest.notifyee !== null) {
                    setPersonName(
                        typeof serviceRequest.notifyee === 'string' ? serviceRequest.notifyee.split(',') : serviceRequest.notifyee,
                    );
                }
                setInvoicingRule(serviceRequest.invoicingRule);
                const daysInArrearsDiv = document.getElementById("daysInArrearsDiv");
                if (serviceRequest.invoicingRule === 1) {
                    daysInArrearsDiv.style.display = "block";
                } else {
                    daysInArrearsDiv.style.display = "none";
                }
                setInitialDocuments(serviceRequest.documents);
                console.log("data",serviceRequest);
            })
            .catch((e) => {
                console.log(e);
            })
    }, [setServiceRequestData, serviceRequestId])

    useEffect(() => {
        callServiceRequestInfo();
    }, [callServiceRequestInfo])

    return (
        <div data-testid='OuterMostDiv' className="OuterMostDiv outerMostDivContainer">
            <div>
                <form data-testid='Form' onSubmit={submitServiceRequest} encType="multipart/form-data" method="POST" autoComplete="off">
                    <div>
                        <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"} spacing={2}
                              className="gridPadding">

                            <Grid item xs={2}></Grid>
                            <Grid item xs={8}>
                                <h4 className="AddNewClientHeading" id="EditServiceRequestHeading" data-testid='EditServiceRequestHeading'> Edit {data.harvestProject.name}</h4>
                            </Grid>
                            <Grid item xs={2}></Grid>

                            <Box sx={{flexGrow: 1}}
                                 xs={12}
                                 className="box-formatting"
                                 data-testid='Box'
                            >
                                <Paper className="Paper cardWidth elevation1" elevation={1} data-testid={"BasicDetailsContainer"}
                                       style={{ height: "310px" }}
                                >
                                    <div data-testid='BasicDetailsHeadingTypography' className="HeadingTypography">Basic details</div>
                                    <Grid container direction="column" justifyContent={"flex-start"} alignItems={"stretch"}
                                          spacing={2} padding={5} className="ParagraphPadding" data-testid='BasicDetailsParagraphPadding'>
                                        <Grid item xs={12} data-testid='EditHarvestClientTextBox'>
                                            <TextField
                                                className="inputWidth"
                                                sx={style}
                                                disabled
                                                name="editClientName"
                                                id="editClientName"
                                                label="Client name"
                                                defaultValue="Client name"
                                                onChange={e => handleChange(e)}
                                                value={data.harvestProject.clientName}
                                            />
                                        </Grid>
                                        <Grid item xs={12} data-testid='HarvestProjectSearchBox'>
                                            {data.harvestProject.id !== 0 &&
                                                <HarvestProjectSearch harvestClientId={data.harvestProject.clientId}
                                                                      harvestProjectId={data.harvestProject.id}
                                                                      harvestProjectName={data.harvestProject.name}
                                                                      onChangeMethod={harvestFieldChange}/>}
                                        </Grid>
                                        <Grid item xs={12} data-testid='JiraBoardSearchBox'>
                                            {data.jiraProject.id !== 0 &&
                                                <JiraProjectSearch jiraProjectId={data.jiraProject.id}
                                                                   jiraProjectName={data.jiraProject.name}
                                                                   onChangeMethod={jiraFieldChange}/>}
                                            {data.jiraProject.id === 0 &&
                                                <JiraProjectSearch jiraProjectId={0}
                                                                    jiraProjectName={""}
                                                                    onChangeMethod={jiraFieldChange}/>
                                            } 
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <Paper
                                    elevation={2}
                                    className="cardWidth"
                                    data-testid={"ProjectDetailsContainer"}
                                >
                                    <div className="HeadingTypography">Project details</div>
                                    <div className={"progressSpinner"} id={"progressSpinner"} hidden={!showSpinner}>
                                        <CircularProgress data-testid={"circleProgress"}/>
                                    </div>
                                    <Grid container className="ParagraphPadding" direction="column" hidden={showSpinner} id={"projectDetailsBox"}
                                          justifyContent={"flex-start"} alignItems={"stretch"} spacing={2} padding={5}>
                                        <Grid item xs={12}>
                                            <FormControl sx={style} className="inputWidth">
                                                <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                    Project type
                                                </InputLabel>
                                            <Select
                                                sx={style}
                                                id="projectType"
                                                select
                                                MenuProp={MenuProps}
                                                label="Project type"
                                                name="projectType"
                                                value={populatedProjectType}
                                                onChange={e => handleChange(e)}
                                            >
                                                {projectType.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className="inputWidth"
                                                sx={style}
                                                disabled
                                                name="startDate"
                                                id="startDate"
                                                label="Start date"
                                                defaultValue="Start date"
                                                onChange={e => handleChange(e)}
                                                value={data.harvestProject.startsOn}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className="inputWidth"
                                                sx={style}
                                                disabled
                                                name="endDate"
                                                id="endDate"
                                                label="End date"
                                                defaultValue="End date"
                                                onChange={e => handleChange(e)}
                                                value={data.harvestProject.endsOn}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className="inputWidth"
                                                sx={style}
                                                disabled
                                                name="timeRetainer"
                                                id="timeRetainer"
                                                label="Time retainer"
                                                defaultValue="Time retainer"
                                                onChange={e => handleChange(e)}
                                                value={data.harvestProject.budget}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl sx={style} className="inputWidth">
                                                <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                    Roll over rules
                                                </InputLabel>
                                            <Select
                                                sx={style}
                                                id="RollOverRules"
                                                name="RollOverRules"
                                                select
                                                MenuProp={MenuProps}
                                                label="Roll over rules"
                                                value={populatedRollOverRules}
                                                onChange={e => handleChange(e)}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                            >
                                                {rollOverRules.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} id="showExpiryTypeDiv">
                                            <FormControl sx={style} className="inputWidth">
                                                <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                    Expiry type
                                                </InputLabel>
                                            <Select
                                                sx={style}
                                                id="expiryType"
                                                name="expiryType"
                                                select
                                                MenuProp={MenuProps}
                                                label="Expiry type"
                                                value={populatedExpiryType}
                                                onChange={e => handleChange(e)}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                            >
                                                {expiryType.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} id="showRollOverHoursDiv" style={{ display: "none" }}>
                                            <Stack direction="row" spacing={1.5}>
                                                <FormControl sx={style} className="inputWidth">
                                                    <InputLabel id="demo-multiple-name-label" sx={{style}}>
                                                        Roll over hours type
                                                    </InputLabel>
                                                <Select
                                                    sx={style}
                                                    id="rollOverHoursType"
                                                    name="rollOverHoursType"
                                                    select
                                                    MenuProp={MenuProps}
                                                    label="Roll over hours type"
                                                    onChange={e => handleChange(e)}
                                                >
                                                    {rollOverHoursType.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                </FormControl>
                                                <TextField
                                                    style={{ width: durationWidth }}
                                                    sx={style}
                                                    id="duration"
                                                    label="Duration"
                                                    variant="outlined"
                                                    type="number"
                                                    onChange={e => handleChange(e)}
                                                />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <Paper className="cardWidth"
                                    data-testid='AlertRulesContainer'
                                    elevation={3}
                                       style={{
                                           height: "400px",
                                       }}
                                >
                                    <div className="HeadingTypography">Alert rules</div>
                                    <Grid container className="ParagraphPadding" direction="column" justifyContent={"flex-start"}
                                          alignItems={"stretch"} spacing={2} padding={5}>
                                        <Grid item xs={12}>
                                            <TextField
                                                className="inputWidth"
                                                sx={style}
                                                id="alertThreshold"
                                                name="alertThreshold"
                                                label="Alert threshold*"
                                                variant="outlined"
                                                type="number"
                                                InputProps={{
                                                    inputProps: {min: 0, max: 100},
                                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                }}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                onChange={e => handleChange(e)}
                                                value={data.alertThreshold}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl sx={style} className="inputWidth" >
                                                <InputLabel id="demo-multiple-name-label" sx={{ style }}>Who do I notify?</InputLabel>
                                                <Select
                                                    id="demo-multiple-name"
                                                    multiple
                                                    value={personName}
                                                    input={<OutlinedInput label="Who do I notify?"/>}
                                                    MenuProps={MenuProps}
                                                    name="notifyee"
                                                    onChange={e => handleChange(e)}
                                                >
                                                    {
                                                        notify.map((notify) => (
                                                            <MenuItem
                                                                      key={notify}
                                                                      value={notify}
                                                            >
                                                                {notify}
                                                            </MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl sx={style} className="inputWidth">
                                                <InputLabel id="demo-multiple-name-label" sx={{ style }}>Invoicing rule</InputLabel>
                                            <Select
                                                sx={style}
                                                id="invoicingRule"
                                                name="invoicingRule"
                                                input={<OutlinedInput label="Invoicing rule"/>}
                                                select
                                                label="Invoicing rule"
                                                MenuProp={MenuProps}
                                                value={populatedInvoicingRule}
                                                onChange={e => handleChange(e)}
                                            >
                                                {invoicingRule.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} id="daysInArrearsDiv">
                                            <TextField
                                                className="inputWidth"
                                                sx={style}
                                                id="Arrears"
                                                label="Days in arrears (1-29)"
                                                variant="outlined"
                                                name="daysInArrears"
                                                type="number"
                                                value={data.daysInArrears}
                                                onChange={e => handleChange(e)}
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                inputProps={{inputMode: 'numeric', pattern:'[1-29]*'}}
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>

                                <Paper className="cardWidth" elevation={4}>
                                    <AgreementsTable
                                        documentNames={initialDocuments}
                                        handleDocumentUpdate={handleDocumentUpdate}
                                    />
                                </Paper>
                            </Box>
                            <Box style={{ marginTop: "20px" }} xs={12}>
                                <Paper
                                    className="cardWidth" style={{ backgroundColor: "#F6F6F6", border: "0" }}>
                                    <div className="d-inline-block float-end buttonPadding editSaveButtonPadding">
                                        <Tooltip disableHoverListener={enableSave} title={"Save button disabled if there are no changes made"}>
                                            <span>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    className="SaveButton"
                                                    style={{
                                                        background: enableSave ? '#ec8d2b' : '#DDDDDD',
                                                        color: enableSave ? '#FFFFFF' : '#AAAAAA',
                                                        fontWeight: "bold"
                                                    }}
                                                    onClick={() => {
                                                        setSaveClicked(true);
                                                    }}
                                                    disabled={!enableSave}>

                                                    {" "}
                                                    SAVE
                                            </Button>
                                            </span>
                                        </Tooltip>
                                    </div>
                                    <div className="d-inline-block float-end buttonPadding editCancellButtonPadding">
                                        <button
                                            className="CancelButton"
                                            variant="outlined"
                                            onClick={() => {
                                                setOpenModal(true);
                                                setSaveClicked(false);
                                            }}
                                        >
                                            CANCEL
                                        </button>
                                        <CancelModal
                                            open={openModal}
                                            onClose={() => setOpenModal(false)}
                                        />
                                    </div>
                                    <div className="d-inline-block float-end buttonPadding editDeleteButtonPadding">
                                        <button
                                            variant="outlined"
                                            className="DeleteButton"
                                            onClick={() => {
                                                setDeleteOpenModal(true);
                                                setSaveClicked(false);
                                            }}
                                        >
                                            DELETE
                                        </button>
                                        <DeleteModal
                                            open={deleteOpenModal}
                                            onClose={() => setDeleteOpenModal(false)}
                                        />
                                    </div>
                                </Paper>
                            </Box>
                        </Grid>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditServiceRequest;
